import { Routes, Route, Navigate } from 'react-router-dom';
import LoginView from './views/loginView';
import MainLayout from './layouts/mainLayout';
import ChatView from './views/chatView';
import InfoView from './views/infoView';
import { ProfileView } from './views/ProfileView';
import SettingsView from './views/settingsView';
import { useAppSelector } from './lib/hook';
import StaffView from './views/staffView';
import IndexView from './views/indexView';
import { authSelector } from './lib/ducks/authDuck';
import ResetPasswordView from './views/resetPasswordView';
import './app.css'
import ForgotPasswordView from './views/ForgotPasswordView';
import { ListView } from './views/ListView';
import FileManagementView from "./views/fileManagamentView"
function App() {
   //const token = useSelector((state: RootState) => state.auth.token);
   const token = useAppSelector(authSelector).token;
   const firstName = useAppSelector(authSelector).user?.first_name;
   const isStaff = useAppSelector(authSelector).user?.is_staff;

   return (
      <Routes>
         {token &&
            <>
               <Route index element={<MainLayout ><ChatView /> </MainLayout>} />
               <Route path="/info" element={<MainLayout ><InfoView /> </MainLayout>} />
               <Route path="/profile" element={<MainLayout ><ProfileView /> </MainLayout>} />
               <Route path="/settings" element={<MainLayout ><SettingsView /> </MainLayout>} />
               <Route path="/search" element={<MainLayout ><ListView /> </MainLayout>} />
               <Route path="/filemanagement" element={<MainLayout> <FileManagementView /> </MainLayout>}/>
               {isStaff && <Route path="/staff" element={<MainLayout> <StaffView /> </MainLayout>} />}
               {isStaff && <Route path="/indexmanagement" element={<MainLayout> <IndexView /> </MainLayout>} />}
               <Route
                  path="*"
                  element={<Navigate to="/" replace={true} />}
               />
            </>
         }
         {!token &&
            <>
               <Route path="/login" element={<LoginView />} />
               <Route path="/reset-password/:token" element={<ResetPasswordView />} />
               <Route path="/forgot-password" element={<ForgotPasswordView />} />
               <Route
                  path="*"
                  element={<Navigate to="/login" replace={true} />}
               />
            </>
         }


      </Routes >
   )
}



export default App;
